module.exports = "<div class=\"hedaer-container\">\r\n  <div [class] = \"imageClass\">\r\n    <img class=\"image\" [src]=\" 'assets/img/' + imageUrl\">\r\n  </div>\r\n  <div [class] = \"contentClass\">\r\n    {{headerText}}\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/logo-header/logo-header.component.html
// module id = ../../../../../src/app/core/components/logo-header/logo-header.component.html
// module chunks = main